// keep these at a bare minimum for what we need to share
// in schemas or error handling and keep aligned first with
// the new registration
export default {
  ACCEPT_TERMS: 'acceptTerms',
  CONTACT_NAME: 'contactName',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  USERNAME: 'username',
}
